// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__20VUL","label":"Category_label__2rPdX","content":"Category_content__24iLy","header":"Category_header__22uS4","location":"Category_location__1Snnf"};